<template>
  <CModal
    size="lg"
    centered
    :closeOnBackdrop="false"
    :show.sync="modalVisible"
    addContentClasses="border-0 modal-border-radius"
    
  >
    <div slot="header" />
    <div slot="header-wrapper" />
    <div slot="body-wrapper">
      <closeButton :setModalVisible="setModalVisible" />
      <CContainer style="padding: 3.125rem">
        <CRow alignHorizontal="center">
          <div class="modal-title">Select Function</div>
        </CRow>
        <CRow alignHorizontal="center">
          <div style="width: 30%">
            <div class="input-label">Select Role</div>
            <select v-model="roleSelect" class="input input-select">
              <!-- <option v-for="item in roleOptions" v-bind:value="item.value">{{ item.text }}</option> -->
            </select>
          </div>
        </CRow>
        <CRow>
          <template v-if="roleSelect != 'user'">
            <manageRole :selected="roleSelect" :setModalVisible="setModalVisible" />
          </template>
        </CRow>
      </CContainer>
    </div>
    <div slot="footer" />
    <div slot="footer-wrapper" />
  </CModal>
</template>

<script>
import manageRole from "./manageRole";
import closeButton from "../closeButton";

export default {
  name: "SelectFunction",
  props: {
    modalVisible: Boolean,
    setModalVisible: Function
  },
  components: {
    manageRole,
    closeButton
  },
  data() {
    return {
      roleSelect: "user",
      roleOptions: [
        { text: "User", value: "user" },
        { text: "Owner", value: "owner" },
        { text: "Admin", value: "admin" }
      ]
    };
  }
};
</script>
